import { History, Check } from "lucide-react";
import { LEGACY_STACK } from "../../data/services";
import Reveal from "../Reveal";

export const Foundations = () => {
  return (
    <section
      id="foundations"
      data-testid="foundations-section"
      className="relative z-10 py-24 md:py-32 bg-[#f4f3ee] border-t border-black/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
            <div>
              <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#2f4bff]">
                / Full-stack foundations
              </span>
              <h2 className="mt-5 font-head text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight max-w-2xl leading-[1.02] text-[#111111]">
                I know the old framework, too.
              </h2>
              <p className="mt-5 font-body text-lg text-neutral-600 max-w-2xl leading-relaxed">
                Modern .NET is where I focus today — but I&apos;ve spent years
                shipping and maintaining production applications on the classic
                .NET Framework, full-stack. If your system runs on Web Forms or
                MVC with JavaScript on the front end, I can jump straight in.
              </p>
            </div>
            <div
              data-testid="foundations-badge"
              className="inline-flex items-center gap-2.5 shrink-0 border border-black/15 bg-white px-5 py-3"
            >
              <History className="h-5 w-5 text-[#2f4bff]" />
              <span className="font-mono-tech text-xs uppercase tracking-[0.15em] text-neutral-700">
                .NET Framework 4.x
              </span>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {LEGACY_STACK.map((item, i) => (
            <Reveal key={item.id} delay={(i % 3) * 0.06}>
              <div
                data-testid={`legacy-card-${item.id}`}
                className="group h-full bg-white border border-black/10 p-8 hover:border-[#2f4bff] hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex items-start gap-3">
                  <Check className="h-5 w-5 mt-1 shrink-0 text-[#2f4bff]" />
                  <div>
                    <h3 className="font-head text-xl font-semibold tracking-tight text-[#111111] leading-snug">
                      {item.title}
                    </h3>
                    <p className="mt-3 font-body text-neutral-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Foundations;
